import React from 'react';
import type { Form } from '../../types/form/Form';
import { FormElement } from './form-element';
import { FormSubmitterProvider } from './form-submitter-context/form-submitter-context';
import 'box-ui-elements/es/elements/common/fonts.scss';
import FormSubmitActionWithContext from './form-submit-action/form-submit-action-with-context';
import FormErrorNotificationWithContext from './form-error-notification/form-error-notification-with-context';
import FormUploadManagerWithContext from './form-upload-manager';
import FormBeforeunloadAlert from './form-beforeunload-alert';
import css from './form-submitter.module.scss';

type Props = {
  fileRequestId: string;
  folderId: string;
  form: Form;
  isAuthenticationRequired: boolean;
  isPreview: boolean;
  isSameEnterprise: boolean;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  onSuccessfulSubmission: any;
  urlId: string;
};

export const FormSubmitter = (props: Props) => {
  const {
    fileRequestId,
    form,
    folderId,
    isPreview,
    isSameEnterprise,
    urlId,
    onSuccessfulSubmission,
    isAuthenticationRequired,
  } = props;
  const { id } = form;
  const { root, components } = form.content;
  const rootElement = components[root];

  return (
    <FormSubmitterProvider
      components={components}
      fileRequestId={fileRequestId}
      folderId={folderId}
      form={form}
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
      formId={id}
      frUrlId={urlId}
      isAuthenticationRequired={isAuthenticationRequired}
      isPreview={isPreview}
      isSameEnterprise={isSameEnterprise}
      onInvalidFormError={() => {}}
      onSuccessfulSubmission={onSuccessfulSubmission}
    >
      <FormBeforeunloadAlert />
      <FormErrorNotificationWithContext />
      <div className={css.formContainer} data-testid="submitter-form-content">
        {/* @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339 */}
        <FormElement key={root.id} element={rootElement} />
      </div>
      <div className={css.submitContainer}>
        <FormSubmitActionWithContext />
      </div>
      <div className={css.uploadManagerContainer}>
        <FormUploadManagerWithContext />
      </div>
    </FormSubmitterProvider>
  );
};
